import React, { useEffect, useState } from 'react';
import M from 'materialize-css'
import { axios } from '../../config'

const Bolsa = () => {

	const [bolsaTrabajo, setBolsaTrabajo] = useState([])

	useEffect(()=>{
		axios.get('/api/trabajaconnosotros')
		.then(r=>{
			setBolsaTrabajo(r.data)
		})
		.catch(r=>alert(r))
	},[])

	return (
		<>
		<div className='card-panel'>
			<h4>Bolsa de trabajo</h4>
			<table>
				<thead>
					<tr>
						<th>#</th>
						<th>Nombre</th>
						<th>Correo</th>
						<th>Teléfono</th>
						<th>Nivel de estudios</th>
						<th>Puesto Solicitado</th>
						<th>Nota</th>
					</tr>
				</thead>
				<tbody>
				{bolsaTrabajo.map((b,i)=>
					<tr key={i}>
						<td>{i+1}</td>
						<td>{b.nombre}</td>
						<td>{b.correo}</td>
						<td>{b.telefono}</td>
						<td>{b.nivel_estudios}</td>
						<td>{b.puesto_solicitado}</td>
						<td>
							<textarea disabled style={{height:100}} value={b.nota} />
						</td>
					</tr>
				)}
				</tbody>
			</table>

		</div>
		</>
	)
}

export default Bolsa
